import { FileTypeReference }  from './TypeModel';
import ShopServiceModel       from '@/models/ShopServiceModel';
import TypeSourceModel        from './TypeSourceModel';
import authStore              from '@/stores/authStore';
import doc                    from '@widesk-core/decorators/doc';
import { downloadBlob }       from '@widesk-core/tools/blobTools';
import model                  from '@widesk-core/decorators/model';

@model.urnResource('stonecode_file_file')
@doc.path('/stonecode_file_files/{?id}')
export default class FileModel extends ShopServiceModel {
	private declare _tsFilters: {
		'fileStatus': id;
		// 'fileStatus.reference': FileFileStatusReference;
		'typeSource': id;
		'typeSource.source': id;
		'typeSource.source.entityUrn': Urn;
		'typeSource.type': id;
		'typeSource.type.reference': FileTypeReference;
		'typeSource.type.service': id;
		'typeSource.type.service.serviceUrn': Urn;
	};

	private declare _tsSorts: {
		'id': string;
		'updatedAt': string;
	};

	@doc.date declare date: Dayjs;
	@doc.string declare description: string;
	@doc.string declare file: string;
	@doc.string declare label: string;
	@doc.string declare name: string;
	@doc.number declare size: number;

	@doc.model(TypeSourceModel) declare typeSource: TypeSourceModel;

	public async download(name?: string) {
		const blob = await this.getBlobAsync();
		return downloadBlob(blob, name || 'file');
	}

	public get downloadPath() {
		return (this.isLoaded && !!this.id) ? `${this.connector['options'].baseURL}${this.path}/_download` : '';
	}

	public async getBlobAsync() {
		return await fetch(this.downloadPath, { headers: { 'X-Platform-Authorization': `Bearer ${authStore.token}` } }).then(response => response.blob());
	}

	public async getFileObjectAsync() {
		const blob = await this.getBlobAsync();

		// Création d'un fichier à partir du Blob
		const file = new File([blob], 'image.jpg', { type: 'image/jpeg' });

		return Object.assign(file, {
			key: undefined,
			preview: URL.createObjectURL(file),
		});
	}
}